<ion-content class="department-work-order">
    <ng-container>
        <app-header [title]="header"></app-header>
        <ion-grid>
            <ion-row>
                <ion-grid class="inner-grid">
                    <ion-row>
                        <ion-col>
                            <ion-row>
                            <ion-col>Cust: &nbsp;&nbsp;{{customerId}} <strong>&nbsp;&nbsp;&nbsp;{{customerName}}</strong></ion-col>
                            </ion-row>
                             <ion-row>
                              <ion-col>Dept: &nbsp;&nbsp;{{Dept}} <strong>&nbsp;&nbsp;&nbsp;{{departmentName}}</strong></ion-col>
                            </ion-row>
                             <ion-row>
                                <ion-col>Emp: &nbsp;&nbsp;{{Emp}}<strong> &nbsp;&nbsp;{{reports?.[0]?.lastName}}, {{reports?.[0]?.firstName}} &nbsp;&nbsp; ( {{reports?.[0]?.deliveryAddress1}})</strong> </ion-col>
                            </ion-row>
                            </ion-col>
                        <ion-col style="float:right">
                        <div style="float:right">
                                    <ion-row >
                                        Report Date: {{ currentDate  | date:'MM/dd/yyyy'}}
                                    </ion-row>
                                     <ion-row style="margin-top:10px">
                                       <button class="printer-button hidden-for-print" (click)="changePrinterView()">{{viewChange === true ? 'Regular Version' : 'Printer Friendly Version'}}</button>
                                    </ion-row>
                                </div>
                      </ion-col>          
                    </ion-row>
                </ion-grid>
            </ion-row>
            <ion-row *ngFor="let report of reports">
                <ion-col>
                    <ion-grid>
                        <ion-row>
                            <ion-col class="small-text"><b>{{report.lastName}}, {{report.firstName}}</b>&nbsp;&nbsp;<span><b>( {{report.deliveryAddress1}})</b></span></ion-col>
                            <ion-col class="small-text"><b>Stop:</b>&nbsp;&nbsp;<span>{{report.stop}}</span></ion-col>
                            <ion-col class="small-text"><b>Garment ID Label: </b>&nbsp;&nbsp;<span>{{report.stopCode}} {{report.employeeCode}}</span></ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <app-work-order-table [rows]="report.workOrders" *ngIf="!viewChange"></app-work-order-table>
                                <app-work-order-table-print class="print-styles" [rows]="report.workOrders" *ngIf="viewChange"></app-work-order-table-print>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-col>
            </ion-row>
            <ion-row class="no-work-orders" *ngIf="!loaded">
                <ion-col>
                    <ion-spinner></ion-spinner>
                </ion-col>
            </ion-row>
            <ion-row class="no-work-orders" *ngIf="loaded && (reports.length <= 0)">
                <ion-col>
                    No Work Orders
                </ion-col>
            </ion-row>
        </ion-grid>
    </ng-container>
</ion-content>